import React from 'react';
import {
  FormElementEnum,
  FormElementType,
  RICMetadata,
} from '@upstart/harmony/lib/legos/ricForm/ricFormTypes';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import {
  SchemaChargeTable,
  SchemaFeeDropdown,
  SchemaFeeInput,
  SchemaFeeTable,
  SchemaFormTitle,
  SchemaLineItem,
  SchemaPriceInput,
  SchemaProductTable,
  SchemaSection,
  SchemaStringInput,
  SchemaSubSection,
  SchemaTradeInInput,
  SchemaIntegerInput,
} from './index';
import SchemaInsuranceTable from './SchemaInsuranceTable';

export const renderElement = ({
  formElement,
  responseData,
  fetchResponseWithUpdatedData,
  isSubSectionElement = false,
  ricMetadata,
}: {
  formElement: FormElementType;
  isSubSectionElement?: boolean;
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
  ricMetadata?: RICMetadata;
}) => {
  switch (formElement.type) {
    case FormElementEnum.FEE_INPUT:
      return (
        <SchemaFeeInput
          formElement={formElement}
          fetchResponseWithUpdatedData={fetchResponseWithUpdatedData}
          responseData={responseData}
          isSubSectionElement={isSubSectionElement}
        />
      );
    case FormElementEnum.FEE_TABLE:
      return (
        <SchemaFeeTable
          formElement={formElement}
          fetchResponseWithUpdatedData={fetchResponseWithUpdatedData}
          responseData={responseData}
          isSubSectionElement={isSubSectionElement}
        />
      );
    case FormElementEnum.FORM_TITLE:
      return <SchemaFormTitle formElement={formElement} />;
    case FormElementEnum.CHARGE_TABLE:
      return (
        <SchemaChargeTable
          formElement={formElement}
          fetchResponseWithUpdatedData={fetchResponseWithUpdatedData}
          responseData={responseData}
          isSubSectionElement={isSubSectionElement}
        />
      );
    case FormElementEnum.FEE_DROPDOWN:
      return (
        <SchemaFeeDropdown
          formElement={formElement}
          fetchResponseWithUpdatedData={fetchResponseWithUpdatedData}
          responseData={responseData}
        />
      );
    case FormElementEnum.LINE_ITEM:
      return (
        <SchemaLineItem
          formElement={formElement}
          fetchResponseWithUpdatedData={fetchResponseWithUpdatedData}
          responseData={responseData}
        />
      );
    case FormElementEnum.PRICE_INPUT:
      return (
        <SchemaPriceInput
          formElement={formElement}
          fetchResponseWithUpdatedData={fetchResponseWithUpdatedData}
          responseData={responseData}
          isSubSectionElement={isSubSectionElement}
        />
      );
    case FormElementEnum.PRODUCT_TABLE:
      return (
        <SchemaProductTable
          formElement={formElement}
          fetchResponseWithUpdatedData={fetchResponseWithUpdatedData}
          responseData={responseData}
          isSubSectionElement={isSubSectionElement}
        />
      );
    case FormElementEnum.INSURANCE_TABLE:
      return (
        <SchemaInsuranceTable
          formElement={formElement}
          fetchResponseWithUpdatedData={fetchResponseWithUpdatedData}
          responseData={responseData}
          isSubSectionElement={isSubSectionElement}
        />
      );
    case FormElementEnum.SECTION:
      return (
        <SchemaSection
          formElement={formElement}
          fetchResponseWithUpdatedData={fetchResponseWithUpdatedData}
          responseData={responseData}
          ricMetadata={ricMetadata}
        />
      );
    case FormElementEnum.STRING_INPUT:
      return (
        <SchemaStringInput
          formElement={formElement}
          fetchResponseWithUpdatedData={fetchResponseWithUpdatedData}
          responseData={responseData}
        />
      );
    case FormElementEnum.INTEGER_INPUT:
      return (
        <SchemaIntegerInput
          formElement={formElement}
          fetchResponseWithUpdatedData={fetchResponseWithUpdatedData}
          responseData={responseData}
        />
      );
    case FormElementEnum.SUBSECTION:
      return (
        <SchemaSubSection
          formElement={formElement}
          fetchResponseWithUpdatedData={fetchResponseWithUpdatedData}
          responseData={responseData}
          ricMetadata={ricMetadata}
        />
      );
    case FormElementEnum.TRADE_IN_INPUT:
      return (
        <SchemaTradeInInput
          formElement={formElement}
          fetchResponseWithUpdatedData={fetchResponseWithUpdatedData}
          responseData={responseData}
          ricMetadata={ricMetadata}
        />
      );
    default:
      return (
        <SchemaLineItem
          formElement={{ type: FormElementEnum.LINE_ITEM, title: 'unhandled' }}
          fetchResponseWithUpdatedData={fetchResponseWithUpdatedData}
          responseData={responseData}
        />
      );
  }
};
